// extracted by mini-css-extract-plugin
export default {"melodyVideo":"HK-z","isFullWidth":"IK-z","landingPageVideo":"JK-z","play":"KK-z","iframeVideo":"LK-z","playHidden":"MK-z","fullwidth":"NK-z"};